import { render, staticRenderFns } from "./SmoothReflow.vue?vue&type=template&id=497468f4&"
import script from "./SmoothReflow.vue?vue&type=script&lang=js&"
export * from "./SmoothReflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports